import { API_BASE_URL } from 'shared/config/url';
import { redirectTo } from 'shared/utils/router/redirectTo';

import { SIGN_OUT_PATH } from './constants';

export const logout = () => {
  redirectTo(`${API_BASE_URL}${SIGN_OUT_PATH}`);
};
